<template>
  <div class="container-fluid">
    <el-form class="form" ref="form" :model="packageForm" label-width="120px">
      <vk-modal :show.sync="showAddModal">
        <vk-modal-close @click="showAddModal = false"></vk-modal-close>

        <vk-modal-title>Add Component</vk-modal-title>
        <!-- {{
        packageForm
        }}-->
        <el-form-item class="form-item" label="Component">
          <el-autocomplete
            class="inline-input"
            v-model="componentId"
            :fetch-suggestions="querySearch"
            placeholder="Please Input"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item class="form-item" label="Quantity">
          <el-input-number v-model="packageForm.quantity" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="customer-btn" @click="onSubmit()">Create</el-button>
        </el-form-item>
      </vk-modal>
    </el-form>
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>{{selectedPackage?selectedPackage.name:'-'}}</h3>
        <hr />
        <!-- {{selectedPackage}} -->
        <el-card class="box-card" v-if="selectedPackage">
          <div slot="header" class="clearfix">
            <span>Components</span>
            <el-button
              style="float: right; padding: 3px 0"
              @click="showAddModal = true"
              type="text"
            >Add</el-button>
          </div>
          <Center v-if="(selectedPackage['packageComponents'].length < 1)">
            <span class="fa fa-ban fa-4x"></span>
            No Component
          </Center>
          <div
            v-for="(_package,index) in selectedPackage['packageComponents']"
            :key="index"
            class="p__component_list"
          >
            <div class="component_list_left">
              <h2>{{_package['componentType']['name']}}</h2>
              <h4>{{_package['quantity']}}</h4>
            </div>
            <i class="fa fa-times-circle fa-2x" @click="deleteComponentConfig(_package['id'])"></i>
          </div>
        </el-card>
        <el-card class="box-card" v-if="selectedPackage" style="margin-top: 12px;">
          <div slot="header" class="clearfix">
            <span>Package Price</span>
            <el-button
              style="float: right; padding: 3px 0"
              @click="priceChangeDisabled = false"
              type="text"
            >Edit</el-button>
          </div>
          <div class="row">
            <el-input-number
              style="flex: 1;"
              :disabled="priceChangeDisabled"
              v-model="packageDefaultPrice"
              controls-position="right"
              :min="1"
            ></el-input-number>
            <button
              v-if="selectedPackage.price != packageDefaultPrice"
              class="btn btn-primary"
              @click="updatePackagePrice"
            >Update</button>
          </div>
        </el-card>
      </div>
    </vk-offcanvas>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
        <h2 style="flex: 1;">Products Packages</h2>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <div class="main-container">
              <div style="width: 100%;">
                <div class="table-header-custom">
                  <el-input
                    style="max-width: 200px"
                    placeholder="Type something"
                    prefix-icon="el-icon-search"
                    v-model="searchTerm"
                  ></el-input>
                  <!-- <button class="btn btn-primary" @click="showOffCanvas = true">Create Package</button> -->
                </div>
                <vue-good-table
                  class="table"
                  :columns="fields_"
                  :rows="systemTypes"
                  :line-numbers="true"
                  :search-options="{enabled: true,  externalQuery: searchTerm}"
                  :pagination-options="{enabled: true}"
                  @on-row-click="tableRowClicked"
                >
                  <!-- <template slot="table-row" slot-scope="props" style="background: red;"> 
                    <span v-if="props.column.field == 'status'">
                      <div
                        class="table_status"
                        :class="{'badge-danger' : statusCalc(props.row.TimeStamp), 'badge-success' : !statusCalc(props.row.TimeStamp)}"
                      ></div>
                    </span>
                    <span v-else-if="props.column.field == 'owner'">{{props.row.ownerName}}</span>
                    <span v-else-if="props.column.field == 'deviceType'">{{props.row.deviceType}}</span>
                    <span v-else-if="props.column.field == 'panelpower'">{{props.row.panelpower}}</span>
                    <span v-else-if="props.column.field == 'deviceId'">{{props.row.InverterId}}</span>
                    <span
                      v-else-if="props.column.field == 'load'"
                    >{{(props.row.OutputLoadPercent * 1) }}%</span>
                    <span
                      v-else-if="props.column.field == 'devicestatus'"
                      style="display: flex; flex-flow: row;"
                    >
                      <battery
                        :width="`18px`"
                        :height="`10px`"
                        :direction="`y`"
                        style="margin-top: 5px;"
                        :level="props.row.BatteryCapacity"
                      ></battery>
                      <span>
                        {{ `${props.row.BatteryCapacity * 1}%` }}
                        {{props.row.batteryMode}}
                      </span>
                    </span>

                    <span v-else>{{props.row[props.column.field]}}</span>
                  </template>-->

                  <template slot="pagination-deviceTypeIdbottom" slot-scope="props">
                    <grey-pagination
                      :total="props.total"
                      :pageChanged="props.pagdeviceTypeIdeChanged"
                      :perPageChanged="props.deviceTypeIdperPageChanged"
                    ></grey-pagination>deviceTypeId
                  </template>deviceTypeId
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem
  // ...
} from "element-ui";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";
export default {
  name: "",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem
  },
  data() {
    return {
      priceChangeDisabled: true,
      packageDefaultPrice: null,
      componentId: "",
      showAddModal: false,
      selectedPackage: null,
      componentData: [],
      packageForm: {
        componentId: null,
        deviceTypeId: null,
        quantity: null
      },
      fields_: [
        {
          key: "name",
          label: "NAME",
          sortable: "true",
          field: "name",
          filterable: true
        },
        {
          key: "description",
          label: "DESCRIPTION",
          sortable: "true",
          field: "description",
          filterable: true
        }
      ],
      systemTypes: [],
      searchTerm: "",
      activeTab: "user_list",
      showOffCanvas: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    handleSelect(item) {
      // console.log(item.id);
      this.packageForm.componentId = item.id;
    },
    querySearch(queryString, cb) {
      var _data = this.componentData;
      var results = queryString
        ? _data.filter(single => this.createFilter(queryString, single))
        : _data;
      cb(results);
    },
    createFilter(queryString, single_item) {
      // console.log(single_item.name);
      return (
        single_item.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      );
    },
    tableRowClicked(params) {
      // console.log(params);
      this.selectedPackage = params.row;
      this.packageForm.deviceTypeId = params.row.id;
      this.packageDefaultPrice = this.selectedPackage.price;
      this.showOffCanvas = true;
    },
    updatePackagePrice() {
      const HTTP = this.$httpUtils.instance;
      const url = `/device_types/${this.packageForm.deviceTypeId}`;
      console.log({
        package: this.packageDefaultPrice,
        before: this.selectedPackage.price
      });
      let updateParam = {
        price: this.packageDefaultPrice
      };
      return HTTP.patch(url, updateParam)
        .then(response => {
          console.log({ response });
          let _tmp = this.fetchSysTypes();
          this.showInfoMsg({
            message: "Package price updated!"
          });
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchSysTypes() {
      const HTTP = this.$httpUtils.instance;
      const url =
        "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url)
        .then(response => {
          this.systemTypes = response.data;
          // console.log({ systemTypes });
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    deleteComponentConfig(_row_id) {
      const HTTP = this.$httpUtils.instance;
      const url = `/package_components/${_row_id}`;
      HTTP.delete(url)
        .then(response => {
          this.fetchSysTypes();
          this.showErrorMsg({
            message: "Deleted!"
          });
          this.selectedPackage = {
            ...this.selectedPackage,
            packageComponents: this.selectedPackage["packageComponents"].filter(
              x => x.id !== _row_id
            )
          };
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    async onSubmit() {
      const HTTP = this.$httpUtils.instance;
      const url = `/package_components`;
      HTTP.post(url, this.packageForm)
        .then(response => {
          let _tmp = this.fetchSysTypes();
          this.showInfoMsg({
            message: "Component Added!"
          });
          this.showAddModal = false;
          // console.log(this.selectedPackage["packageComponents"]);
          let packageAdded = {
            ...this.packageForm,
            componentType: this.componentData.find(
              x => x.id == this.packageForm.componentId
            )
          };
          // this.selectedPackage = this.systemTypes.find(x=>x.id == this.packageForm.deviceTypeId)
          this.selectedPackage = {
            ...this.selectedPackage,
            packageComponents: [
              ...this.selectedPackage["packageComponents"],
              packageAdded
            ]
          };
          this.packageForm = {
            ...this.packageForm,
            componentId: null,
            quantity: null
          };
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    getComponents() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get("/components/", {}).then(components => {
        //console.log(JSON.stringify(components.data))
        container.componentData = components.data.map(x => ({
          ...x,
          value: x.name
        }));
        // container.setAccessLocal(saveRole.join);
      });
    }
  },
  mounted() {
    this.fetchSysTypes();
    this.getComponents();
  }
};
</script>

<style lang="scss" scoped>
.p__component_list {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  cursor: pointer;
  .component_list_left {
    display: flex;
    flex-flow: row;
    justify-content: space-evenly;
    align-items: center;
    flex: 1;
    h2 {
      font-size: 17px;
      text-transform: capitalize;
      flex: 1;
    }
    h4 {
      margin-left: 100px;
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/inventory/packages.vue